module.exports = __webpack_public_path__ + "static/img/desktop-jsgl.59ee3c81.png";